import { render, staticRenderFns } from "./DynamicToggleSelector.vue?vue&type=template&id=0a5f5959&scoped=true"
import script from "./DynamicToggleSelector.vue?vue&type=script&lang=js"
export * from "./DynamicToggleSelector.vue?vue&type=script&lang=js"
import style0 from "./DynamicToggleSelector.vue?vue&type=style&index=0&id=0a5f5959&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5f5959",
  null
  
)

export default component.exports